import {documentToPlainTextString} from '@contentful/rich-text-plain-text-renderer'

import {t} from '@github-ui/swp-core/lib/utils/localization'
import {PrimerComponentSubnavSchema} from '@github-ui/swp-core/schemas/contentful/contentTypes/primerComponentSubnav'

import {defineBrandPage, optionalSection, optionalTemplateField} from '../../../brand/components/BrandPage'
import {
  findAllByContentType,
  findByContentType,
  GenericSectionSchema,
  type GenericSection,
  type PricingTable,
} from '../../../brand/lib/types/contentful'

import type {FeaturesTableProps} from './components/generic/FeaturesTable/FeaturesTable.types'

export const securityPlansPage = defineBrandPage({
  faq: optionalSection('securityPlansFAQSection', GenericSectionSchema, faqSection =>
    findByContentType(faqSection.fields.content, 'primerComponentFaqGroup'),
  ),
  hero: optionalSection('securityPlansHeroSection', GenericSectionSchema, heroSection => ({
    component: findByContentType(heroSection.fields.content, 'primerComponentHero'),
    pricingOptions: findByContentType(heroSection.fields.content, 'primerComponentPricingOptions'),
  })),
  pricing: optionalSection('securityPlansPricingSection', GenericSectionSchema, toPricingSectionContent),
  subnav: optionalTemplateField('subnav', PrimerComponentSubnavSchema),
})

function toPricingSectionContent(pricingSection: GenericSection) {
  return {
    pricingTable: toPricingTableContent(findAllByContentType(pricingSection.fields.content, 'pricingTable')),
    ctaBanner: findByContentType(pricingSection.fields.content, 'primerComponentCtaBanner'),
  }
}

function toPricingTableContent(pricingTableComponents: PricingTable[]): FeaturesTableProps[] {
  return pricingTableComponents
    .map(item => ({
      id: item.sys.id,
      ...item.fields,
    }))
    .map(item => ({
      ...item,
      title: item.title || '',
      aria: {included: t('Included'), notIncluded: t('Not included')},
      columns: item.columns
        .map(column => ({
          id: column.sys.id,
          ...column.fields,
        }))
        .map(column => ({
          ...column,
          title: column.title,
          price: column.price,
          currency: column.currency,
          ctaPrimary: column.ctaPrimary?.fields,
          ctaSecondary: column.ctaSecondary?.fields,
        })),
      rows: item.rows
        .map(row => ({
          id: row.sys.id,
          ...row.fields,
        }))
        .map(row => ({
          ...row,
          description: row.description ? documentToPlainTextString(row.description) : '',
          content: row.content.map(cell => ({
            availability: cell.fields.availability,
            customText: cell.fields.customText ? documentToPlainTextString(cell.fields.customText) : '',
          })),
        })),
    }))
}
